module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_duo_cuad_14.05308916.png";